/* OG 3 Nov 2026 - size tabs for styled product descriptions (.og-desc [data-og-sizes]).
   Builds one tab per size and follows the size the customer picks in the product form. */
(function () {
  'use strict';
  function sizeKey(text) {
    var m = String(text || '').match(/(\d{2,3})\s*[×xX*]\s*(\d{2,3})/);
    if (!m) return null;
    var a = +m[1], b = +m[2];
    return Math.min(a, b) + 'x' + Math.max(a, b);
  }
  function activate(box, key) {
    var panels = box.querySelectorAll('.og-desc__size');
    var known = false;
    for (var i = 0; i < panels.length; i++) if (panels[i].getAttribute('data-size') === key) known = true;
    if (!known) return;
    for (var j = 0; j < panels.length; j++) {
      var on = panels[j].getAttribute('data-size') === key;
      panels[j].hidden = !on;
      panels[j].classList.toggle('is-active', on);
    }
    var tabs = box.querySelectorAll('.og-desc__tab');
    for (var k = 0; k < tabs.length; k++) {
      var sel = tabs[k].getAttribute('data-size') === key;
      tabs[k].classList.toggle('is-active', sel);
      tabs[k].setAttribute('aria-selected', sel ? 'true' : 'false');
      tabs[k].tabIndex = sel ? 0 : -1;
    }
  }
  function selectedSize() {
    var fields = document.querySelectorAll('form[action*="/cart/add"] input[type="radio"]:checked, form[action*="/cart/add"] select, .xo-product-info-variant input[type="radio"]:checked');
    for (var i = 0; i < fields.length; i++) {
      var k = sizeKey(fields[i].value);
      if (k) return k;
    }
    return null;
  }
  function build(box) {
    if (box.getAttribute('data-og-ready')) return;
    box.setAttribute('data-og-ready', '1');
    var panels = box.querySelectorAll('.og-desc__size');
    if (panels.length < 2) return;
    var bar = document.createElement('div');
    bar.className = 'og-desc__tabs';
    bar.setAttribute('role', 'tablist');
    Array.prototype.forEach.call(panels, function (p) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'og-desc__tab';
      b.setAttribute('role', 'tab');
      b.setAttribute('data-size', p.getAttribute('data-size'));
      b.textContent = p.getAttribute('data-label') || p.getAttribute('data-size');
      b.addEventListener('click', function () { activate(box, p.getAttribute('data-size')); });
      bar.appendChild(b);
      p.setAttribute('role', 'tabpanel');
    });
    box.insertBefore(bar, panels[0]);
    box.classList.add('has-tabs');
    activate(box, selectedSize() || panels[0].getAttribute('data-size'));
  }
  function init() {
    var boxes = document.querySelectorAll('.og-desc [data-og-sizes]');
    for (var i = 0; i < boxes.length; i++) build(boxes[i]);
  }
  function follow(e) {
    var t = e.target;
    if (!t || !('value' in t)) return;
    var k = sizeKey(t.value);
    if (!k) return;
    var boxes = document.querySelectorAll('.og-desc [data-og-sizes].has-tabs');
    for (var i = 0; i < boxes.length; i++) activate(boxes[i], k);
  }
  document.addEventListener('change', follow);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  window.addEventListener('load', init);
})();
